import { render, staticRenderFns } from "./preserveEvidence.vue?vue&type=template&id=1cab31ba&scoped=true&"
import script from "./preserveEvidence.vue?vue&type=script&lang=js&"
export * from "./preserveEvidence.vue?vue&type=script&lang=js&"
import style0 from "./preserveEvidence.vue?vue&type=style&index=0&id=1cab31ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cab31ba",
  null
  
)

export default component.exports